export default "__VITE_ASSET__CRhusOfj__"